import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class MasterGrievanceListService {

  constructor(public httpClient:HttpClient) { }

  async masterGrievanceList() {

    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadAllGrievanceByDpId, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  async selfAssign(data){
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.selfAssigen, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  async loadMasterGrievanceStatus(page: number, size: number,statusid){
    const data={
      statusId:statusid
    }
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadAllGrievanceByDpIdStatusWise+`?page=${page}&size=${size}`,data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }


  loadStatus(){
   
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadStatusForSearch,{})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

  fetchFilterList(
    page: number,
    size: number,
    filterText?: number
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
      const data={
        filterText:filterText
      }
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.loadAllGrievanceById + reqParams,data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
  }
}
